<template>
  <div class="select" v-if="floorData.data.length > 0">
    <div class="title">
      <div></div>
      <div class="mid">{{ floorData.floorTitle }}</div>
      <div></div>
    </div>
    <div style="display:flex;justify-content: flex-start;flex-wrap: wrap;">
      <div
        class="item"
        v-for="(item, i) in floorData.data"
        :key="i"
        @click="$jumpToPage(item)"
      >
        <div class="top "><img :src="item.imageUrl" alt="" /></div>
        <div class="bottom">
          <div class="first">{{ item.title }}</div>
          <div class="num" v-if="item.brandSalesAmount">
            {{ item.brandSalesAmount }}人已买
          </div>
          <div class="last">
            <div>
              <span>¥{{ item.subtitleFirst }}</span
              >起
            </div>
            <div>{{ item.subtitleSecond }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="item">
        <div class="top"><img src="@/assets/img/select2.png" alt="" /></div>
        <div class="bottom">
          <div class="first">沃尔玛</div>
          <div class="num">151.4万人已买</div>
          <div class="last">
            <div><span>¥50</span>起</div>

            <div>电子卡</div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="top"><img src="@/assets/img/select3.png" alt="" /></div>
        <div class="bottom">
          <div class="first">天猫</div>
          <div class="num">151.4万人已买</div>
          <div class="last">
            <div><span>¥50</span>起</div>

            <div>超市券</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: ['floorData'],

  data() {
    return {}
  },
  created() {},
  computed: {},
  methods: {
    gotoUrl(a) {
      if (a.titleUrl) {
        location.href = a.titleUrl
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.select {
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.2rem 0;
    .mid {
      margin: 0 0.12rem;
      font-weight: 500;
      font-size: 0.19rem;
    }
    div:first-child,
    div:last-child {
      width: 0.45rem;
      height: 0.01rem;
      background: #999999;
    }
  }
  .item {
    width: 1.13rem;
    height: fit-content;
    background: #ffffff;
    border-radius: 0.16rem;
    box-shadow: 0px 0.01rem 0.02rem 0px rgba(192, 192, 192, 0.08);
    overflow: hidden;
    margin-left: 0.1rem;
    margin-bottom: 0.1rem;
    &:nth-child(2),
    &:nth-child(3) {
      margin-left: 0.08rem;
    }
    .top {
      width: 100%;
      height: 0.57rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .bottom {
      // padding-right: 0.03rem;
      // padding-left: 0.03rem;
      padding: 0 0.08rem;
      text-align: left;
      padding-bottom: 0.07rem;
      .first {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.15rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        color: #000000;
        line-height: 0.21rem;
        margin-top: 0.07rem;
      }
      .num {
        font-size: 0.12rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #333;
        line-height: 0.2rem;
        margin-top: 0.005rem;
      }
      .last {
        margin-top: 0.01rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        letter-spacing: -0.01rem;
        div:first-child {
          margin-right: 0.02rem;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: center;
          color: #e91639;
          line-height: 0.22rem;
          span {
            font-size: 0.15rem;
          }
        }
        div:last-child {
          height: 0.14rem;
          border: 0.01rem solid #e91639;
          border-radius: 0.02rem;
          color: #e91639;
          font-size: 0.08rem;
          box-sizing: border-box;
          line-height: 0.14rem;
          padding: 0 0.02rem;
        }
      }
    }
  }
}
</style>
